import HttpBaseService from '@/services/http/HttpBaseService'
import Event from '@/objects/Event'

class SettingsService extends HttpBaseService {

  fetchSettings = async () => {
    const response = await this.executeRequest('/content-api/collections/settings/entries?sort=order', 'GET')
    const result = response.data
    return result
  }

}

export default new SettingsService()
